import React, {Fragment} from "react";
import {Route, Switch} from "react-router-dom";

import {ROUTES} from "../../../routes";
import LookUserInput from "./lookUserInput";
import LookUserPhoneInput from "./lookUserPhoneInput";

const LookUserInputs = (props) => {

  const {inputsValidated} = props;

  return (
    <Fragment>
      <LookUserInput property="email" inputsValidated={inputsValidated} />
      <Switch>
        <Route path={ROUTES.login}>
          <LookUserInput property="password" inputsValidated={inputsValidated} />
        </Route>
      </Switch>
      <Switch>
        <Route path={ROUTES.register}>
          <Fragment>
            <LookUserInput property={"firstName"} inputsValidated={inputsValidated} />
            {/*<LookUserPhoneInput property={"phoneNumber"} inputsValidated={inputsValidated} />*/}
            <LookUserPhoneInput property={"phoneNumber"} inputsValidated={inputsValidated} />
            <LookUserInput property={"postal"} inputsValidated={inputsValidated} />
          </Fragment>
        </Route>
      </Switch>
    </Fragment>
  )
};

export default LookUserInputs
